module.exports = "<div :class=\"['page-layout', {'toggle-aside': toggleFlag}]\"> <aside-layout :menus=menus></aside-layout> <div class=page-layout-wrap> <header-layout :bread-crumb-data=breadCrumbData></header-layout> <div class=page-layout-content> <div class=page-layout-bg> <router-view></router-view> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/components/layout/page-layout/page-layout.tpl
// module id = 865
// module chunks = 2